import { Project, ProjectIssues, SortField, SortOrder } from '../types/Project';

const statusOrder = { active: 1, pending: 2, done: 3 };

export const sortProjects = (
  projects: Project[],
  field: SortField,
  order: SortOrder
): Project[] => {
  const sorted = [...projects].sort((a, b) => {
    // First, always sort by status
    const statusDiff = statusOrder[a.status] - statusOrder[b.status];
    if (statusDiff !== 0) return statusDiff;

    // Then sort by the selected field
    let aValue: string | number | null = a[field];
    let bValue: string | number | null = b[field];

    // Handle null values
    if (aValue === null && bValue === null) return 0;
    if (aValue === null) return 1;
    if (bValue === null) return -1;

    // Convert dates to timestamps for comparison
    if (field === 'startDate' || field === 'endDate') {
      aValue = new Date(aValue as string).getTime();
      bValue = new Date(bValue as string).getTime();
    }

    // Handle string comparison (case-insensitive)
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    if (aValue < bValue) return order === 'asc' ? -1 : 1;
    if (aValue > bValue) return order === 'asc' ? 1 : -1;
    return 0;
  });

  return sorted;
};

export const filterProjectsByBrand = (
  projects: Project[],
  brandFilter: string
): Project[] => {
  if (!brandFilter.trim() || brandFilter === 'all') return projects;
  return projects.filter((project) => project.brandName === brandFilter);
};

export const filterProjectsBySearch = (
  projects: Project[],
  searchQuery: string
): Project[] => {
  if (!searchQuery.trim()) return projects;
  const query = searchQuery.toLowerCase();
  return projects.filter((project) =>
    project.projectTitle.toLowerCase().includes(query)
  );
};

export const getUniqueBrands = (projects: Project[]): string[] => {
  const brands = projects.map((project) => project.brandName);
  return Array.from(new Set(brands)).sort();
};

export const getTotalIssues = (issues: ProjectIssues): number => {
  return (
    issues.pendingOptins +
    issues.pendingScriptSubmission +
    issues.pendingScriptApproval +
    issues.pendingContentSubmission +
    issues.pendingContentApproval +
    issues.pendingPost +
    issues.pendingPayment
  );
};

export const getIssuesList = (issues: ProjectIssues): { label: string; count: number }[] => {
  const issuesList = [
    { label: 'Opt-ins pendentes', count: issues.pendingOptins },
    { label: 'Envio de roteiro pendente', count: issues.pendingScriptSubmission },
    { label: 'Aprovação de roteiro pendente', count: issues.pendingScriptApproval },
    { label: 'Envio de conteúdo pendente', count: issues.pendingContentSubmission },
    { label: 'Aprovação de conteúdo pendente', count: issues.pendingContentApproval },
    { label: 'Postagem pendente', count: issues.pendingPost },
    { label: 'Pagamento pendente', count: issues.pendingPayment },
  ];

  return issuesList.filter((issue) => issue.count > 0);
};
